import { render, staticRenderFns } from "./activate-step.vue?vue&type=template&id=1b40c646"
import script from "./activate-step.vue?vue&type=script&lang=js"
export * from "./activate-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports